import { type Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { onClickOutside } from '@vueuse/core'

import {
    type TooltipCustom,
    useTooltipStore,
} from '@/directives/tooltip/tooltip'
import type { TooltipFragment } from '@/graphql/api'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

export function useTooltip(): {
    tooltip: Ref<TooltipFragment | TooltipCustom | null>
    pageType: Ref<PageType | null>
    close: () => void
    open: (
        t: TooltipFragment | TooltipCustom,
        triggerEl: HTMLElement,
        pageType: string
    ) => void
    tooltipEl: Ref<HTMLElement | null>
} {
    const tooltipStore = useTooltipStore()
    const { close, open } = tooltipStore
    const { tooltip, pageType, triggerElement } = storeToRefs(tooltipStore)

    const tooltipEl = ref<HTMLElement | null>(null)

    onClickOutside(tooltipEl, close, { ignore: [triggerElement] })

    return {
        tooltip,
        pageType,
        close,
        open,
        tooltipEl,
    }
}
